const Backbone = require('backbone');
const validator = require('validator');
const customValidator = require('./../../../../../lib/customvalidators');

module.exports = Backbone.Model.extend({
	api: 'local',
	validate: function(attrs) {
		const postalCode = attrs.postalCode;
		customValidator.extend();
		if (/undef/i.test(postalCode) || !validator.isZip(postalCode)) {
			return 'invalid zipcode';
		}
		return '';
	},
	url: function() {
		return `/app/api/products/${this.get('productCompositeId')}/estimateddelivery/${this.get('postalCode')}`;
	}
});
